import { ModalController, ToastController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { Component, OnInit} from '@angular/core';
import { MeteorObservable } from 'meteor-rxjs';
import { ISDEV, APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";
import { Http } from '@angular/http';

@Component({
	templateUrl: 'support.html'
})
export class SupportComponent implements OnInit {
	supportMessage: string | void;
	supportMessageAttachments: string[] = [];
  public isDev = ISDEV;

  constructor(
    private _app: App,
  	public modalCtrl: ModalController,
  	public navParams: NavParams,
  	public viewCtrl: ViewController,
  	private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    public httpService: HttpService
  ) { }
    ionViewDidEnter() {
      this._app.setTitle(APP_TITLE);
    }
  ngOnInit() {}

  showToast(message: string) {
    let toast = this.toastCtrl.create({
      message,
      duration: 2500,
      position: 'bottom',
      dismissOnPageChange: true,
    });

    toast.present();
    return toast;
  }

  closeView() {
  	this.viewCtrl.dismiss();
  }

  sendSupportMessage() {
  	const emailBody = this.supportMessage;
  	const attachmentUrls = this.supportMessageAttachments;
    /*
  	MeteorObservable.call('sendContactEmail',
	  		emailBody,
	  		attachmentUrls
	  	).subscribe({
	  		next: () => {
	  			this.showToast('Support message sent');
	  			this.closeView();
	  		},
	  		error: (e: Error) => {
					this.handleError(e);
	  		}
      });
    */

    this.httpService.MeteorCall(
      'sendContactEmail',
      emailBody,
      attachmentUrls
    ).then(() => {
      this.showToast('Support message sent');
      this.closeView();
    })
    .catch((e: Error) => {
      this.handleError(e);
    });

	  } // end of sendSupportMessage

	  handleError(e: Error): void {
    console.error(e);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }


  }



// WEBPACK FOOTER //
// ./src/pages/support/support.ts